import axiosInstance from "../lib/axiosInstance";

const baseUrl = process.env.REACT_APP_API_URL;

const bookingModel = class {

    async editBookingDetails(formData=[], id) {
        const data = await axiosInstance.put(baseUrl+"/admin/bookings/"+id, formData);
        return data;
    }

    async deleteBooking(id){
        return await axiosInstance.delete(baseUrl+"/admin/bookings/"+id);
    }
}

export default new bookingModel();
